import {AppState} from "types/domain";
import {Kontrollrapport} from "types/generated";
import {Feilmelding} from "pages/Innlogging";

function initiellInnloggingsskjemaState(): InnloggingsskjemaState {
    return {
        laster: false,
        feilmelding: Feilmelding.Ingen,
        kontrollId: "",
        kundeId: "",
        dokumentNokkel: ""
    }
}

const initiellAppState: AppState = {
    name: "SJEKKER_OM_LOGGET_INN"
};

export type InnloggingsskjemaState = {
    laster: boolean,
    feilmelding: Feilmelding,
    kontrollId: string,
    kundeId: string,
    dokumentNokkel: string
}

export type AppAction =
    | { type: "LOGG_INN" }
    | { type: "LOGG_UT" }
    | { type: "VIS_INNLOGGING" }
    | { type: "VIS_INNLOGGING_FEILMELDING", value: Feilmelding }
    | { type: "VIS_LASTET_KONTROLLRAPPORT", value: Kontrollrapport }
    | { type: "SETT_KONTROLL_ID", value: string }
    | { type: "SETT_KUNDE_ID", value: string }
    | { type: "SETT_DOKUMENTNOKKEL", value: string }

const actions = (state: AppState, action: AppAction): AppState => {
    switch (state.name) {
        case "SJEKKER_OM_LOGGET_INN":
            switch (action.type) {
                case "LOGG_UT":
                    return { name: "VISER_UTLOGGET_SIDE" };
                case "VIS_LASTET_KONTROLLRAPPORT":
                    return {name: "VISER_LASTET_KONTROLLRAPPORT", kontrollrapport: action.value, feilmelding: false};
                case "VIS_INNLOGGING":
                    return {
                        name: "VISER_INNLOGGINGSSKJEMA",
                        innloggingsskjema: initiellInnloggingsskjemaState()
                    };
                default:
                    return state;
            }
        case "VISER_INNLOGGINGSSKJEMA":
            switch (action.type) {
                case "LOGG_INN":
                    return {...state, innloggingsskjema: {...state.innloggingsskjema, laster: true}};
                case "VIS_INNLOGGING":
                    return {...state, innloggingsskjema: initiellInnloggingsskjemaState()};
                case "VIS_LASTET_KONTROLLRAPPORT":
                    return {name: "VISER_LASTET_KONTROLLRAPPORT", kontrollrapport: action.value, feilmelding: false};
                case "VIS_INNLOGGING_FEILMELDING":
                    return {
                        ...state,
                        innloggingsskjema: {...state.innloggingsskjema, laster: false, feilmelding: action.value}
                    };
                case "SETT_KONTROLL_ID":
                    return {...state, innloggingsskjema: {...state.innloggingsskjema, kontrollId: action.value}};
                case "SETT_KUNDE_ID":
                    return {...state, innloggingsskjema: {...state.innloggingsskjema, kundeId: action.value}};
                case "SETT_DOKUMENTNOKKEL":
                    return {...state, innloggingsskjema: {...state.innloggingsskjema, dokumentNokkel: action.value}};
                default:
                    return state;
            }
        case "VISER_LASTET_KONTROLLRAPPORT":
            switch (action.type) {
                case "LOGG_UT":
                    return { name: "VISER_UTLOGGET_SIDE" };
                default:
                    return state;
            }
        case "VISER_UTLOGGET_SIDE":
            switch (action.type) {
                case "VIS_INNLOGGING":
                    return { name: "VISER_INNLOGGINGSSKJEMA", innloggingsskjema: initiellInnloggingsskjemaState() };
                default:
                    return state;
            }
    }
};

export {initiellInnloggingsskjemaState, initiellAppState}
export default actions;